import { paymentT } from "./payment";
import { thor } from "./thor";
import { Enums } from "../thor.enums";
import { CategoryField } from "./categories";

export namespace onlineT {
    export interface Item extends thor.ItemGet {
        finalSoldPrice?: number;
        inView?: boolean;
        payment?: paymentT.Payment[];
        paymentStatus?: onlineT.past.ItemStatus;
        grouped?: boolean;
    }

    export interface LastBidder {
        anonymous_bidder_id: number;
        birthday?: string;
        civility?: string;
        company?: thor.UserProCompany;
        email?: string;
        first_name?: string;
        last_name?: string;
        location?: thor.UserLocation;
        phone_landline?: thor.UserPhone;
        phone_mobile?: thor.UserPhone;
        user_id: string;
    }

    export interface ItemPost {
        id?: number;
        caution?: number;
        sale_id?: number;
        starting_price?: number;
        reserve_price?: number;
        has_caution?: boolean;
        last_bid?: LastBid;
    }

    export interface LastBid extends LastBidder {
        amount: number;
        is_from_order: boolean;
        subscription_id: number;
        created: string;
        item_id: number;
        id?: number;
        sale_id?: number;
        is_past: boolean;
        is_winner: boolean;
        has_ended: boolean;
        paddle_number: number;
        subscription_created?: string;
        sale_ended_at?: string;
        user?: User;
    }

    interface User {
        id: string;
        first_name: string;
        last_name: string;
    }

    export namespace future {
        /**
         * Enum for container status in future containers list
         * @readonly
         * @enum {string} undated, container unpublished and undated
         * @enum {string} created, container unpublished and dated
         * @enum {string} published, container currently published on Ie.com
         * @enum {string} scheduled, container scheduled to be published
         */
        export enum ContainerStatus {
            UNDATED = "undated",
            CREATED = "created",
            PUBLISHED = "published",
            SCHEDULED = "scheduled"
        }

        export interface ContainerResult {
            unpublished: any[];
            published: any[];
        }

        export interface ContainerResultCounts {
            unpublishedListCount: number;
            publishedListCount: number;
        }
    }

    export namespace past {
        /**
         * Enum for item status in past items list
         * @readonly
         * @enum {string} closing, item sale still in progress while container is closed
         * @enum {string} unpaid, item sold but unpaid
         * @enum {string} paid, item sold and everything is paid
         * @enum {string} unsold, item unsold
         * @enum {string} canceled, item withdrawn from sale
         *     while container status is `published`. Equals item state `hidden`
         */
        export enum ItemStatus {
            CLOSING = "closing",
            UNPAID = "unpaid",
            PAID = "paid",
            UNSOLD = "unsold",
            CANCELED = "canceled"
        }

        export interface Items {
            count: number;
            items: Item[];
            itemsByLastBidder: ItemsResultLastBidder[];
        }

        export interface ItemsResultLastBidder {
            lastBidder: LastBidder;
            items: Item[];
            payments: paymentT.Payment[];
        }

        export type ItemsResult = {
            [index in ItemStatus]: Items;
        };
    }
}

export interface OnlineSalePost extends thor.SalePost {
    auction_type: Enums.AuctionType;
    contract_id: number;
    start_at?: string;
}

export type OnlineItemGet = onlineT.Item;

export type DatepickerRange = {
    [date in keyof { start_at; end_at }]: {
        min: Date;
        max: Date;
    }
};

export interface OnlineItemsFilterParams {
    auctioned?: boolean;
    category?: string;
    caution?: number;
    confirmed?: boolean;
    containerStatus?: {
        isScheduled: boolean;
        saleStarted: boolean;
        status: Enums.SaleStatus;
    };
    description?: string;
    field?: CategoryField;
    hidden?: boolean;
    id?: number;
    is_item_paid?: boolean;
    is_item_unpaid?: boolean;
    is_item_unsold?: boolean;
    isPast?: boolean;
    media?: boolean;
    noBids?: boolean;
    query?: string;
    reserve_price?: number;
    starting_price?: number;
    suppressed?: boolean;
    withBids?: boolean;
}

export interface OnlineCaution {
    caution: {
        amount: number;
    };
}
